export enum EStatusArquivoFiscal {
    Processando = 1,
    Concluido = 2,
    Falha = 3,
    Excluido = 4
}
